import apiClient from './api';
import { AuthResponse } from '@/types';

interface ApiResponse<T> {
  success: boolean;
  data: T;
  message?: string;
}

export interface AuthMethods {
  magicLogin: boolean;
}

/**
 * Passwordless login API (dark-launched: the backend 404s these routes while the flag is off,
 * and /methods tells the login page whether to show the option at all).
 */
export const magicLoginService = {
  async getMethods(): Promise<AuthMethods> {
    const response = await apiClient.get<ApiResponse<AuthMethods>>('/api/auth/methods');
    return response.data.data;
  },

  async requestLink(email: string): Promise<void> {
    await apiClient.post('/api/auth/magic/request', { email });
  },

  async verifyCode(email: string, code: string, rememberMe: boolean): Promise<AuthResponse> {
    const response = await apiClient.post<ApiResponse<AuthResponse>>('/api/auth/magic/verify', { email, code, rememberMe });
    return response.data.data;
  },

  /** `email` is only sent when the server asked for it (link opened in a different browser than the request). */
  async verifyLink(token: string, rememberMe: boolean, email?: string): Promise<AuthResponse> {
    const response = await apiClient.post<ApiResponse<AuthResponse>>('/api/auth/magic/verify-link', {
      token,
      rememberMe,
      ...(email ? { email } : {}),
    });
    return response.data.data;
  },
};
